"use client";
import PushNotificationCard from './push-notification-card';

export default function ClientOnlyPushNotificationCard() {
	return <PushNotificationCard />;
}